<template>
  <detail-layout-full-width-center>
    <template slot="main">
      <div>
        <!-- <base-logo :filename="logo" :alt="$t('app.app_name')" class="mb-6"/> -->
        <h1 class="mt-3 text-2xl text-secondary dark:text-darkblue-50 font-bold md:text-3xl">{{ $t('app.access_denied') }}</h1>
        <p class="mt-4 text-secondary-500 dark:text-darkblue-200 font-normal">{{ $t('feedback.error.requred_modules_not_available') }}</p>
        <p class="mt-4 text-secondary-500 dark:text-darkblue-200 font-normal">
          <base-scoped-list key="modules-list" :items="requirements" :props="{ label: 'Nombre' }" deep default-open-all />
        </p>
        <p class="mt-4 text-secondary-500 dark:text-darkblue-200 font-normal">{{ $t('feedback.info.retry_and_contact_msg') }}</p>
        <div class="flex items-center mt-6 gap-x-3">
          <router-link :to="{ name: 'dashboard' }">
            <base-button 
              mode="primary"
              :text="$t('app.dashboard')" 
            />
          </router-link>
        </div>
      </div>
    </template>
  </detail-layout-full-width-center>
</template>
<script>
import { i18n } from '@/i18n'
import Status from '@/classes/scoped-list/Status'
import DetailLayoutFullWidthCenter from '@/components/layout/DetailLayoutFullWidthCenter.vue'
export default {
  name: 'missing-module-error',
  components: {
    DetailLayoutFullWidthCenter, 
  },
  data () {
    return {
      defaultProps: {
        label: 'Nombre',
        children: 'children'
      }
    }
  },
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    logo: function () {
      if (this.darkMode) {
        return 'logo-invoize-dark.svg'
      }
      return 'logo-invoize.svg'
    },
    modules: function () {
      return this.$store.getters['config/MODULOS']?.map(x => ({ ...x, contratado: this.userModules.includes(x.id) })) ?? []
    },
    userModules: function () {
      return this.$store.getters['auth/modules']?.map(x => x.idModulo) ?? []
    },
    tempNavigationData: function () {
      return this.$store.getters['navigation/tempNavigationData']
    },
    requirements: function () {
      const findModule = idModulo => this.modules.find(m => m.id === idModulo) || { id: idModulo, Nombre: idModulo }
      const reqmodules = this.tempNavigationData?.modules ?? []
      const result = []
      for (const index in reqmodules) {        
        const requirement = reqmodules[index]
        if (requirement.length) {
          if (requirement.length === 1) {
            const module = findModule(requirement[0])
            const { status, statuslabel } = module.contratado ? { status: Status.SUCCESS } : { status: Status.ERROR, statuslabel: i18n.t('feedback.error.required_module_not_contracted') }
            result.push({ key: index, status, statuslabel, ...module })
          } else {
            const { status, statuslabel } = { status: Status.ERROR, statuslabel: i18n.t('feedback.error.required_module_not_contracted') }
            const group = { key: index, Nombre: i18n.t('app.at_least_one_of_modules'), status, statuslabel, items: [] }
            var contratado = false
            for (const childIndex in requirement) {
              const childModule = findModule(requirement[childIndex])
              const { childStatus, childStatusLabel } = childModule.contratado ? { childStatus: Status.SUCCESS } : { childStatus: status, childStatusLabel: statuslabel }
              contratado |= childModule.contratado
              group.items.push({ key: `${index}.${childIndex}`, status: childStatus, statuslabel: childStatusLabel, ...childModule })
            }
            if (contratado) {
              group.status = Status.SUCCESS
              group.statuslabel = ''
              group.items.forEach(x => {
                if (!x.contratado) {
                  x.status = Status.WARNING
                  x.statuslabel = i18n.t('feedback.warning.optional_module_not_contracted')
                } 
              })
            }
            result.push(group)
          }
        }   
      }
      return result
    }
  },
  methods: {
  }
}
</script>
<style scoped>
</style>
